import { baseApi } from "@/redux/api/baseApi";
import { TJobsResponse } from "./jobsType";
import { FileDetails } from "../scriptDetails/scriptDetailsSlice";

export interface AcceptJobPayload {
  video_ids: string[];
  email: string;
  deliverables?: string;
  isSelectedForMultipleVideos: boolean;
  order_id: string;
  actor_id?: string;
  supportingCastVideos?: {
    role?: string;
    video?: FileDetails;
    hash?: string;
    thumbnail?: string;
  }[];
}

interface AcceptJobResponse {
  success: boolean;
  message?: string;
}
export type TQueryParam = {
  name: string;
  value: boolean | React.Key;
};
const jobsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreatorJobs: builder.query({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }
        return {
          url: "/creator-job/get-creator-jobs-v2",
          method: "GET",
          params: params,
        };
      },
      // query: (email) => ({
      //   url: "/creator-job/get-creator-jobs-v2",
      //   params: { email },
      // }),
      providesTags: ["CreatorJobs"],
    }),

    // acceptJob: builder.mutation({
    //   query: ({ order_id, video_id, actor_id }) => ({
    //     url: `/creator-canvas/apply-actor/${order_id}/${video_id}/${actor_id}`,
    //     method: "POST",
    //   }),
    //   invalidatesTags: ["CreatorJobs", "CreatorProjects"],
    // }),
    applyToJob2: builder.mutation<AcceptJobResponse, AcceptJobPayload>({
      query: (body) => ({
        url: `/creator-canvas/apply-actor-v2`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["CreatorJobs", "CreatorProjects"],
    }),
  }),
});

export const {
  useGetCreatorJobsQuery,
  // useAcceptJobMutation,
  useApplyToJob2Mutation,
} = jobsApi;
